import { render, staticRenderFns } from "./EditLocataire.vue?vue&type=template&id=93efb62e&"
import script from "./EditLocataire.vue?vue&type=script&lang=ts&"
export * from "./EditLocataire.vue?vue&type=script&lang=ts&"
import style0 from "./EditLocataire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports